import { Injectable } from '@angular/core';
import { RequestMaterialDTO } from '../../api/plyca-dtos-v2';
import { PropertyService } from '../../properties/property.service';

@Injectable()
export class ProcurementProjectValidations {
  propertyService: PropertyService;

  constructor() { }

  /*

    TODO: BORRAR CUANDO TERMINAR EL DESARROLLO!!

    hayLimiteNumParticipantes => participantsLimit(model)
    esConcursoProyectos ==>  isDesignContest(model)
    esAbierto           ==>  isOpenContrat(model)
    esMenor             ==>  isMinorContrat(model)
    esRestringido       ==>  isRestrictedContrat (model)
    esPNegociado        ==>  isNegotiated(model)
    esDCompetitivo      ==>  isCompetitiveDialogue(model)
    esAdjAcuerdoMarco   ==>  isBasedFrameworkAgreement(model)
    esAbiertoSimpli     ==>
    esAbiertoSimpliAbrev==> isOpenSimplifiedAbreviated
    esLicitacionNegociada ==> isTenderWithNegotiation(model)
    esNegociadoSinPubli ==> isNegotiatedWithoutPublicity(model)
    esAsociacionInnov   ==> isAssociationForInnovation
    esComprasCC ==> isCentralizedPurchases

    esObras              ==> isWorks(model)
    esSuministros        ==> isGoods(model)
    esServicios          ==> isServices (model)
    esConcesionServicios ==> isServicesConcession
    esConcesionObras     ==> isWorkConcession
    esServicioPublico    ==> isServiciesPublic
    esConsultoria        ==> isConsultancy
    esCPrivado           ==> isPrivate



    esConcesion          ==> isConcession
    esAcuerdoMarco       ==> isComplementarySystemAM_SDA
    esContratoBaseSD     ==> isComplementarySystemBaseSD

    importe estimado ==>  amountEstimatedAmount(model)

    esFadjPluralidadCriterios = isAwardingVariousCriteria(model)

 !esMenor && !esObras && !esCPrivado
   */


  private static isComplementarySystemBaseSD(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      return model.classification.complementarySystem == 'CSDA<>SISTCOMPLEMENTARIO'
    }
    return false;
  }

  private static isComplementarySystemAM_SDA(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let isAM =
        model.classification.complementarySystem == 'AM<>SISTCOMPLEMENTARIO';
      let isSDA =
        model.classification.complementarySystem == 'SDA<>SISTCOMPLEMENTARIO';
      return isAM || isSDA;
    }
    return false;
  }

  private static isConcession(model: any) {
    if (model.classification && model.classification.subTypeCode) {
      let isConcession =
        model.classification.subTypeCode == undefined
          ? false
          : model.classification.subTypeCode.identifier == '01<>MODALIDADEXPTE';
      return isConcession;
    }
    return false;
  }

  private static isAwardingVariousCriteria(model: any) {
    if (model.classification && model.classification.awardMethod) {
      let isAwardingVariousCriteria =
        model.classification.awardMethod == undefined
          ? false
          : model.classification.awardMethod.identifier ==
          'P<>FORMASADJUDICACION';
      return isAwardingVariousCriteria;
    }
    return false;
  }

  public isEnabledContractFolderId(model: any) {
    let resultado = false;

    if (model.context.configurations.isAutoGenerateContractFolderIdProperty !== undefined) {
      resultado = !model.context.configurations.isAutoGenerateContractFolderIdProperty.value;
    }

    // Tiene prioridad sobre la propiedad anteriormente ctada en el caso de que exista
    if (model.context.configurations.generateNumberDurigProcessing.value) {
      resultado = false;
    }

    // Tiene prioridad lo que hay en la tabla CONFIGURACION_EXP_GENERICO
    if (model.context && model.context.configurations) {
      if (model.context.configurations.modesConfigProject) {
        model.context.configurations.modesConfigProject.value.forEach(config => {
          if (config.documentClass.identifier === '00002'
            && config.processingMode.identifier === model.classification.processingMode.identifier) {
            resultado = !config.activeGenerationNumber;
          }
        });
      }
    }
    return resultado;

  }

  private static isPrivate(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isPrivate =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '09<>TIPOEXPTE';
      return isPrivate;
    }
    return false;
  }
  private static isConsultancy(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isConsultancy =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '03<>TIPOEXPTE';
      return isConsultancy;
    }
    return false;
  }

  private static isSpecialAdministrative(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isSpecialAdministrative =
        model.classification.typeCode == undefined
          ? false
          : (model.classification.typeCode.identifier == '07<>TIPOEXPTE' ||
            model.classification.typeCode.identifier == '09<>TIPOEXPTE' ||
            model.classification.typeCode.identifier == '12<>TIPOEXPTE');
      return isSpecialAdministrative;
    }
    return false;
  }

  private static isServiciesPublic(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServiciesPublic =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '06<>TIPOEXPTE';
      return isServiciesPublic;
    }
    return false;
  }
  public static isWorkConcession(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isWorkConcession =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '10<>TIPOEXPTE';
      return isWorkConcession;
    }
    return false;
  }

  public static isServicesConcession(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServicesConcession =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '11<>TIPOEXPTE';
      return isServicesConcession;
    }
    return false;
  }
  private static isGoods(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isGoods =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '02<>TIPOEXPTE';
      return isGoods;
    }
    return false;
  }

  private static isWorks(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isWorks =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '01<>TIPOEXPTE';
      return isWorks;
    }
    return false;
  }
  private static isServices(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServices =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '04<>TIPOEXPTE';
      return isServices;
    }
    return false;
  }
  private static isPatrimonial(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServices =
        model.classification.typeCode == undefined
          ? false
          : model.classification.typeCode.identifier == '12<>TIPOEXPTE';
      return isServices;
    }
    return false;
  }
  private static amountEstimatedAmount(model: any) {
    if (model.budget) {
      let amountEstimatedAmount =
        model.budget.estimatedAmount == undefined
          ? 0
          : model.budget.estimatedAmount;
      return amountEstimatedAmount;
    }
    return 0;
  }
  private static isDesignContest(model: any) {
    if (model.type) {
      let isDesignContest =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier == 'CP<>PROCEDIMIENTOSCONTRA';
      return isDesignContest;
    }
    return false;
  }

  // Modo Dialogo Competitivo
  private static isCompetitiveDialogue(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'DC');
  }

  private static isOpenSimplifiedAbreviated(model: any) {
    if (model.type) {
      let isOpen = model.type.identifier == 'AS<>PROCEDIMIENTOSCONTRA';
      let isAbreviated = model.classification.abbreviated != undefined && model.classification.abbreviated;
      return isOpen && isAbreviated;
    }
    return false;
  }
  private static isTenderWithNegotiation(model: any) {
    if (model.type) {
      let isTenderWithNegotiation =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier == 'LN<>PROCEDIMIENTOSCONTRA';
      return isTenderWithNegotiation;
    }
    return false;
  }
  private static isAssociationForInnovation(model: any) {
    if (model.type) {
      let isAssociationForInnovation =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier == 'API<>PROCEDIMIENTOSCONTRA';
      return isAssociationForInnovation;
    }
    return false;
  }
  private static isNegotiatedWithoutPublicity(model: any) {
    if (model.type) {
      let isNegotiatedWithoutPublicity =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier == 'NSP<>PROCEDIMIENTOSCONTRA';
      return isNegotiatedWithoutPublicity;
    }
    return false;
  }
  private static participantsLimit(model: any) {
    if (model.type) {
      let participantsLimit =
        model.characteristicsContractObject.participantsLimit == undefined
          ? false
          : model.characteristicsContractObject.participantsLimit;
      return participantsLimit;
    }
    return false;
  }

  //esAdjAcuerdoMarco = modoProc.equals("AAM")]
  private static isBasedFrameworkAgreement(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'AAM');
  }

  //esMenor = modoProc.equals("M")
  public static isMinorContrat(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'M');
  }
  //si es restringuido: [esRestringido = modoProc.equals("R") || (esConcursoProyectos && hayLimiteNumParticipantes)]
  private static isRestrictedContrat(model: any) {
    let isRestrictedContract = ProcurementProjectValidations.isTypeMode(model, 'R');
    let isRestricted = isRestrictedContract ||
      (ProcurementProjectValidations.isDesignContest(model) &&
        ProcurementProjectValidations.participantsLimit(model));

    return isRestricted;
  }

  //si es abierto: [esAbierto = modoProc.equals("A") || (esConcursoProyectos && !hayLimiteNumParticipantes)]
  private static isOpenContrat(model: any) {
    let isOpenContract = ProcurementProjectValidations.isTypeMode(model, 'A');
    let isOpen =
      isOpenContract ||
      (ProcurementProjectValidations.isDesignContest(model) &&
        !ProcurementProjectValidations.participantsLimit(model));
    return isOpen;
  }


  public static isNegotiated(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'N');
  }

  public isvisibleComplementarySystem(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      return (
        (ProcurementProjectValidations.isOpenContrat(model) ||
          ProcurementProjectValidations.isNegotiated(model) ||
          ProcurementProjectValidations.isRestrictedContrat(model) ||
          ProcurementProjectValidations.isBasedFrameworkAgreement(model)) &&
        ((ProcurementProjectValidations.isWorks(model) ||
          ProcurementProjectValidations.isGoods(model) ||
          ProcurementProjectValidations.isServices(model)) &&
          !ProcurementProjectValidations.isAssociationForInnovation(model) &&
          !ProcurementProjectValidations.isDesignContest(model))
      );
    }

    return false;
  }

  public isVisibleSelectionCriteriaAward(model: any) {
    // Menores con Licitacion Electronica
    // Si es  tipo de procedimiento es distinto de AM o es un CSDA
    let condition1 = (ProcurementProjectValidations.isMinorContrat(model) && model.classification && model.classification.submissionMethodCode);
    let condition2 = (!ProcurementProjectValidations.isBasedFrameworkAgreement(model) ||
      (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO') ||
      (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO'));

    if (condition1) {
      return true;
    }
    if (condition2) {
      return true;
    }

    return false;

  }

  public isRequiredSelectionCriteriaAward(model: any) {
    return (
      ProcurementProjectValidations.isNegotiated(model) ||
      ProcurementProjectValidations.isCompetitiveDialogue(model) ||
      ((ProcurementProjectValidations.isOpenContrat(model) ||
        ProcurementProjectValidations.isRestrictedContrat(model)) &&
        ProcurementProjectValidations.isAwardingVariousCriteria(model))
    );
  }

  public isVisibleSelectionCriteria(model: any) {
    return (
      ProcurementProjectValidations.isRestrictedContrat(model) ||
      ProcurementProjectValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectValidations.isTenderWithNegotiation(model) ||
      ProcurementProjectValidations.isNegotiatedWithoutPublicity(model)
    );
  }

  public isVisibleClassificationCompany(model: any) {
    //visibleClasifEmpre = !esMenor && !esAdjAcuerdoMarco && ((esObras && valorEstimado >= impClasifEmpr)||esServicios);
    if (model.type) {
      let amountSelectionCriteria = model.context &&
        model.context.configurations &&
        model.context.configurations.amountSelectionCriteria;
      return (
        !ProcurementProjectValidations.isMinorContrat(model) &&
        !ProcurementProjectValidations.isBasedFrameworkAgreement(model) &&
        ((ProcurementProjectValidations.isWorks(model) &&
          ProcurementProjectValidations.amountEstimatedAmount(model) >=
          amountSelectionCriteria.value) ||
          ProcurementProjectValidations.isServices(model))
      );
    }
    return false;
  }

  public isVisibleIncome(model: any) {
    // if (esServicioPublico && esAdministrativoEspecial && esConcesionObras && esConcesionServicios){
    return (
      ProcurementProjectValidations.isSpecialAdministrative(model)) ||
      ProcurementProjectValidations.isWorkConcession(model) ||
      ProcurementProjectValidations.isServicesConcession(model)
  }

  public isVisibleSpecialEconomicTerm(model: any) {
    // boolean visibleRegEconomico =(esServicioPublico && esConcesion) || esConcesionObras || esConcesionServicios;
    return (
      (ProcurementProjectValidations.isServiciesPublic(model) &&
        ProcurementProjectValidations.isConcession(model)) ||
      ProcurementProjectValidations.isWorkConcession(model) ||
      ProcurementProjectValidations.isServicesConcession(model)
    );
  }

  public isVisibleSubTypeCode(model: any) {
    let isActiveSubTypeWorks =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveSubTypeWorks)
        ? model.context.configurations.isActiveSubTypeWorks.value
        : true;
    if (isActiveSubTypeWorks) {
      return (
        !ProcurementProjectValidations.isWorkConcession(model) &&
        (ProcurementProjectValidations.isServiciesPublic(model) ||
          ProcurementProjectValidations.isGoods(model) ||
          ProcurementProjectValidations.isWorks(model) ||
          ProcurementProjectValidations.isPatrimonial(model))
      );
    } else {
      return (
        ProcurementProjectValidations.isServiciesPublic(model) ||
        ProcurementProjectValidations.isGoods(model) ||
        ProcurementProjectValidations.isPatrimonial(model)
      );
    }
  }

  public isVisible(model: any) {
    let isActiveSubTypeWorks =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveSubTypeWorks)
        ? model.context.configurations.isActiveSubTypeWorks.value
        : true;
    if (isActiveSubTypeWorks) {
      return (
        !ProcurementProjectValidations.isWorkConcession(model) &&
        (ProcurementProjectValidations.isServiciesPublic(model) ||
          ProcurementProjectValidations.isGoods(model) ||
          ProcurementProjectValidations.isWorks(model))
      );
    } else {
      return (
        ProcurementProjectValidations.isServiciesPublic(model) ||
        ProcurementProjectValidations.isGoods(model)
      );
    }
  }

  public isVisibleProcessJustificationNegotiated(model: any) {
    return (
      ProcurementProjectValidations.isNegotiated(model) &&
      (ProcurementProjectValidations.isWorks(model) ||
        ProcurementProjectValidations.isServices(model) ||
        ProcurementProjectValidations.isGoods(model) ||
        ProcurementProjectValidations.isWorkConcession(model) ||
        ProcurementProjectValidations.isServicesConcession(model))
    );
  }

  public isVisibleNoticeDocumentReference(model: any) {
    // boolean visibleAnuInfPrevia = esAbierto || esRestringido || esDCompetitivo || ((esPNegociado && hayPublicidad) || esLicitacionNegociada);
    let visible = (ProcurementProjectValidations.isOpenContrat(model) ||
      ProcurementProjectValidations.isRestrictedContrat(model) ||
      ProcurementProjectValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectValidations.isTenderWithNegotiation(model));

    if (visible && !ProcurementProjectValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return true;
    } else {
      return false;
    }
  }

  public isVisibleNoticeDocumentReferenceRDL_3_20(model: any) {
    // boolean visibleAnuInfPrevia = esAbierto || esRestringido || esDCompetitivo || ((esPNegociado && hayPublicidad) || esLicitacionNegociada);
    let visible = (ProcurementProjectValidations.isOpenContrat(model) ||
      ProcurementProjectValidations.isRestrictedContrat(model) ||
      ProcurementProjectValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectValidations.isTenderWithNegotiation(model));

    if (visible && model.applicableLegislation.identifier && model.applicableLegislation.identifier == '70<>VERSIONNORMATIVA') {
      return true;
    } else {
      return false;
    }
  }


  public provisionalGuaranteeAmount(model: any) {
    if (
      model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage !=
      undefined
    ) {
      let amountGuarantee =
        model.budget != undefined &&
          model.budget.amountExcludingTaxes != undefined
          ? model.budget.amountExcludingTaxes
          : 0;
      if (ProcurementProjectValidations.isComplementarySystemAM_SDA(model)) {
        amountGuarantee = ProcurementProjectValidations.amountEstimatedAmount(
          model
        );
      }
      return (
        (amountGuarantee *
          model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) /
        100
      );
    }
    return undefined;
  }

  public static isComplementarySystem_CBAM_CSDA(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let complementarySystemBased =
        model.classification.complementarySystem == undefined
          ? false
          : model.classification.complementarySystem.identifier ==
          'CBAM<>SISTCOMPLEMENTARIO' ||
          model.classification.complementarySystem.identifier ==
          'CSDA<>SISTCOMPLEMENTARIO';
      return complementarySystemBased;
    }
    return false;
  }

  public isVisibleCentralizedPurchases(model: any): boolean {
    // Verifica si el sistema complementario está presente y en la lista permitida
    const complementarySystemBased =
      model.classification?.complementarySystem?.identifier &&
      ['CBAM<>SISTCOMPLEMENTARIO', 'CSDA<>SISTCOMPLEMENTARIO'].includes(
        model.classification.complementarySystem.identifier
      );

    // Verifica si la unidad organizativa tiene la marca de centralización
    const orgCompras = model.organizationalUnit?.customFields?.ORG_ES_CENTRAL_COMPRAS_STD?.toString() === '1';
    return ((complementarySystemBased === undefined || !complementarySystemBased) && orgCompras);
  }


  public isBasedFrameworkAgreement(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      return ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(
        model
      );
    }

    return false;
  }

  public isVisibleCompanyToInvite(model: any) {
    let isVisibleCompanyToInvite = ProcurementProjectValidations.isMinorContrat(model) || ProcurementProjectValidations.isNegotiated(model)
      || (model.classification.tenderBasedOwnClassification);
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

    // Contrato Basado sin padre
    let isNoRelatedBaseContract = ProcurementProjectValidations.isNoRelatedBaseContract(model);

    if (isVisibleCompanyToInvite || isCBAM) {
      if (!isCBAM || (isCBAM && isNoRelatedBaseContract)) {
        return true;
      }
    }

    // Si es distinto de Contrato Basado, o es un Contrato Basado sin padre
    return false;
  }

  public isVisibleCompanyToInviteCBAM(model: any) {
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

    // Contrato Basado sin padre
    let isNoRelatedBaseContract = ProcurementProjectValidations.isNoRelatedBaseContract(model);

    // Si es un contrato basado y tiene padre
    if (isCBAM && !isNoRelatedBaseContract) {
      return true;
    } else {
      return false;
    }
  }


  /*public isVisibleCompanyToInvite(model: any) {
    let isVisibleCompanyToInvite = ProcurementProjectValidations.isMinorContrat(model) || ProcurementProjectValidations.isNegotiated(model);
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
    return isVisibleCompanyToInvite && !isCBAM;
  }
  public isVisibleCompanyToInviteCBAM(model: any) {
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
    return isCBAM;
  }
  */

  public clearFromControlCompanyToInvite(model: any) {
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
    let isVisibleCompanyToInvite = ProcurementProjectValidations.isMinorContrat(model) || ProcurementProjectValidations.isNegotiated(model);
    return isVisibleCompanyToInvite;

  }


  private static isComplementarySystem_CSDA(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      if (model.classification && model.classification.complementarySystem) {
        let isCSDA =
          model.classification.complementarySystem == undefined
            ? false
            : (model.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO')
        return isCSDA;
      }
    }

    return false;
  }

  public isVisibleLotsPanel(model: any) {
    /*let isMinorContract = false;
    if (model.type) {
      isMinorContract = model.type == undefined
        ? false
        : model.type.identifier == 'M<>PROCEDIMIENTOSCONTRA';
    }*/

    /*if (ProcurementProjectValidations.isMinorContrat(model)) {
      return false;
    }

    if (ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(model)) {
      return false;
    }

    return true;*/

    if (model.type) {
      let isMinorContract = ProcurementProjectValidations.isMinorContrat(model);

      if (isMinorContract || ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(model)) {
        return false;
      }
      return true;
    }
    return false;
  }

  public isVisibleCriteriaTechnicalFinancial(model: any) {
    return !ProcurementProjectValidations.isMinorContrat(model) &&
      !ProcurementProjectValidations.isBasedFrameworkAgreement(model);
  }

  public isVisibleWorkProgram(model: any) {
    let isMinor = ProcurementProjectValidations.isMinorContrat(model);
    let isConsultancy = ProcurementProjectValidations.isConsultancy(model);
    let isServices = ProcurementProjectValidations.isServices(model);
    let isPrivate = ProcurementProjectValidations.isPrivate(model);
    let isWorks = ProcurementProjectValidations.isWorks(model);
    return !isMinor && (isConsultancy || isServices || isPrivate || isWorks);
  }

  public isVisibleSubcontractTerm(model: any) {
    return !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isServiciesPublic(model);
  }

  public isVisibleContractExtension(model: any) {
    return !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isWorks(model) && !ProcurementProjectValidations.isPrivate(model);
  }

  public valueFinalFinancialGuaranteePercentage(model: any) {
    if (model.breakdownLot.totalLots.budget.finalFinancialGuarantee) { // si se ha marcado que hay garantia definitiva
      if (model.breakdownLot.totalLots.budget.finalFinancialGuaranteePercentage) {
        return model.breakdownLot.totalLots.budget.finalFinancialGuaranteePercentage; // el valor introducido pr el usuario
      } else {
        //  Valor establecido en la configuaracion
        let finalFinancialGuaranteePerc = model.context && model.context.configurations
          ? model.context.configurations.valueDefaultFinancialGuaranteePercentage.value
          : undefined;
        return finalFinancialGuaranteePerc;
      }
    } else {
      return undefined;
    }
  }

  public valueProvisionalGuaranteePercentage(model: any) {
    if (model.breakdownLot.totalLots.budget.provisionalGuarantee) { // si se ha marcado que hay garantia definitiva
      if (model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) {
        return model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage; // el valor introducido pr el usuario
      } else {
        // Valor establecido en la configuracion
        let valueProvGuaranteePerc = model.context && model.context.configurations
          ? model.context.configurations.valueDefaultGuaranteeProvisional.value
          : undefined;
        return valueProvGuaranteePerc;
      }
    } else {
      return undefined;
    }
  }




  public isVisibleLowTendersDescription(model: any) {
    return !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isCentralizedPurchases(model);
  }

  public isVisibleFichCriteriaTechnicalFinancial(model: any) {
    let isVisibleCriteriaTechnicalFinancial = !ProcurementProjectValidations.isMinorContrat(model) &&
      !ProcurementProjectValidations.isBasedFrameworkAgreement(model) &&
      !ProcurementProjectValidations.isComplementarySystemBaseSD(model) &&
      !ProcurementProjectValidations.isOpenSimplifiedAbreviated(model)

    let isVisibleCompanyToInvite = ProcurementProjectValidations.isMinorContrat(model) || ProcurementProjectValidations.isNegotiated(model);
    return isVisibleCriteriaTechnicalFinancial || isVisibleCompanyToInvite;
  }

  public isVisiblePriceRevision(model: any) {
    let isVisible = !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isBasedFrameworkAgreement(model) && !ProcurementProjectValidations.isCentralizedPurchases(model);
    return isVisible;

  }

  public isVisiblePriceRevisionWorks(model: any) {
    let isVisible = !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isBasedFrameworkAgreement(model) && !ProcurementProjectValidations.isCentralizedPurchases(model);
    return isVisible && ProcurementProjectValidations.isWorks(model);

  }

  public isVisiblePriceRevisionNotWorks(model: any) {
    let isVisible = !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isBasedFrameworkAgreement(model) && !ProcurementProjectValidations.isCentralizedPurchases(model);
    return isVisible && !ProcurementProjectValidations.isWorks(model);

  }

  /*public isVisibleCategory(model: any) {
    if (ProcurementProjectValidations.isComplementarySystem_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
        return true;
      }
    }

    return false;
  }*/

  public isVisibleCategory(model: any) {
    // Desglosable en lotes el acuerdo marco
    if (ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
        // Visible Unicamente si esta desglosado en lotes el Acuerdo Marco
        if (model.contractingSystem.originalContractingSystemID.breakdownLot && model.contractingSystem.originalContractingSystemID.breakdownLot.apportioned) {
          return true;
        } else if (model.procurementProjectAM && model.procurementProjectAM.breakdownLot && model.procurementProjectAM.breakdownLot.apportioned) {
          return true;
        }
      }
    }
    return false;
  }

  public isVisiblePrice(model: any) {
    // !hayIngreso && (esConcesion  || esConcesionObras || esConcesionServicios)
    return (
      (!model.breakdownLot.totalLots.specialEconomicTerm.income &&
        (ProcurementProjectValidations.isConcession(model) ||
          ProcurementProjectValidations.isWorkConcession(model) ||
          ProcurementProjectValidations.isServicesConcession(model)))
    );
  }

  public valueProvisionalGuaranteePercentage2(model: any) {
    if (model.breakdownLot.totalLots.budget.provisionalGuarantee) { //si se ha marcado que hay garantia definitiva
      if (model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) {
        return model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage; //el valor introducido pr el usuario
      } else {
        //el valor establecido en la configuaracion
        return model.context.configurations.valueDefaultGuaranteeProvisional.value;
      }
    } else {
      return undefined;
    }
  }


  public valueProvisionalGuarantee(model: any) {

    let isAM = model.classification.complementarySystem && model.classification.complementarySystem == 'AM<>SISTCOMPLEMENTARIO';
    let amountGuarantee = 0;
    let provisionalGuaranteeAmount = 0;

    if (isAM !== undefined) {
      if (model.budget && model.budget.estimatedAmount !== undefined) {
        amountGuarantee = model.budget.estimatedAmount;
      }
    } else {
      if (model.budget && model.budget.amountExcludingTaxes !== undefined) {
        amountGuarantee = model.budget.amountExcludingTaxes;
      }
    }

    if (model.breakdownLot.totalLots.budget && model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage != undefined) {
      if (amountGuarantee != 0) {
        return ((amountGuarantee * model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) / 100);
      }
    }
    return 0;
  }

  private static isCentralizedPurchases(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'T');
  }

  public isVisibleMethod(model: any) {
    let isVisibleMethodRevPrice = model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.priceRevision &&
      model.breakdownLot.totalLots.priceRevision.priceRevision &&
      (model.breakdownLot.totalLots.priceRevision.priceRevision == 'SI' || model.breakdownLot.totalLots.priceRevision.priceRevision == 'SOLO_PRORROGA') &&
      !ProcurementProjectValidations.isWorks(model)
    return isVisibleMethodRevPrice;
  }

  public isVisibleBudgetDeterminationSystem(model: any) {
    //plantilla.setApariencia("panelDetPresupuesto", null, (esConsultoria || esServicios) && !esComprasCC , true);
    return ((ProcurementProjectValidations.isConsultancy(model) || ProcurementProjectValidations.isServices(model)) && (!ProcurementProjectValidations.isCentralizedPurchases(model)));
  }

  private static isRate(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.rate !== undefined && model.breakdownLot.totalLots.specialEconomicTerm.rate);
  }
  private static isCompensation(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.compensation !== undefined && model.breakdownLot.totalLots.specialEconomicTerm.compensation);
  }
  private static isCanon(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.canon !== undefined && model.breakdownLot.totalLots.specialEconomicTerm.canon);
  }
  private static isPrice(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.price !== undefined && model.breakdownLot.totalLots.specialEconomicTerm.price);
  }

  private static isCleanBudget(model: any) {
    let subTypeCodeCorrect = ((ProcurementProjectValidations.isServiciesPublic(model) && ProcurementProjectValidations.isConcession(model)) ||
      ProcurementProjectValidations.isWorkConcession(model) ||
      ProcurementProjectValidations.isServicesConcession(model)
    );

    let notPrice = (!ProcurementProjectValidations.isPrice(model) &&
      (ProcurementProjectValidations.isCanon(model) || ProcurementProjectValidations.isRate(model) || ProcurementProjectValidations.isCompensation(model)));

    if (subTypeCodeCorrect && notPrice) {
      // Se limpia el campo Tipo Impositivo
      model.budget.taxRate = '';
      return true;
    }


    return false;
  }

  private static isNoTax(model: any) {

    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier == '0<>TIPO_IMPUESTO');

    return noTax;
  }

  public valueBudgetAmountExcludingTaxes(model: any) {
    let amountExcludingTaxes = ProcurementProjectValidations.isCleanBudget(model) &&
      (model.budget != undefined &&
        model.budget.amountExcludingTaxes != undefined)
      ? 0
      : model.budget.amountExcludingTaxes;

    return amountExcludingTaxes;
  }

  public enabledAmountExcludingTaxes(model: any) {
    return !ProcurementProjectValidations.isCleanBudget(model);
  }

  public valueBudgetTotalTaxes(model: any) {
    let totalTaxes = (ProcurementProjectValidations.isCleanBudget(model) || ProcurementProjectValidations.isNoTax(model))
      ? 0
      : model.budget.totalTaxes;



    return totalTaxes;

  }

  public enabledBudgetTotalTaxes(model: any) {
    let cleanBudget = ProcurementProjectValidations.isCleanBudget(model);
    let noTax = ProcurementProjectValidations.isNoTax(model);
    if (!cleanBudget && !noTax) {
      return true;
    }
    return false;
  }

  // Valor: Tipo de Impuesto
  public valueBudgetTaxType(model: any): string {
    let taxType = ProcurementProjectValidations.isCleanBudget(model)
      ? { "identifier": "0<>TIPO_IMPUESTO" }
      : model.budget.taxType;
    return taxType;
  }

  // Habilitar: Tipo de Impuesto
  public enabledBudgetTaxType(model: any) {
    return !ProcurementProjectValidations.isCleanBudget(model);
  }

  // Visibilidad: Tabla de Anualidades
  public isVisibleBudgetAccountLine(model: any) {
    let visibleAnu = (model.classification && model.classification.complementarySystem &&
      model.classification.complementarySystem != 'AM<>SISTCOMPLEMENTARIO' && model.classification.complementarySystem != 'SDA<>SISTCOMPLEMENTARIO');
    let cleanBudget = ProcurementProjectValidations.isCleanBudget(model);

    if ((visibleAnu != undefined && visibleAnu) || !cleanBudget) {
      return true;
    }
    return false;
  }

  // Visibilidad Cofinanciacion
  public isVisibleCofinancing(model: any) {
    let cleanBudget = ProcurementProjectValidations.isCleanBudget(model);
    if (cleanBudget != undefined && !cleanBudget) {
      return true;
    }
    return false;
  }

  // Habilitar: Cofinanciación
  public enabledCofinancing(model: any) {
    return !ProcurementProjectValidations.isCleanBudget(model);
  }

  // Valor: Tipo impositivo
  public valueTaxRate(model: any) {
    let cleanBudget = ProcurementProjectValidations.isCleanBudget(model);
    let noTax = ProcurementProjectValidations.isNoTax(model);
    let taxRate = cleanBudget || noTax
      ? ''
      : model.budget.taxRate;
    return taxRate;
  }

  // Habilitar: Tipo Impositivo
  public enabledTaxRate(model: any) {
    let cleanBudget = ProcurementProjectValidations.isCleanBudget(model);
    let noTax = ProcurementProjectValidations.isNoTax(model);
    if (!cleanBudget && !noTax) {
      return true;
    }
    return false;
  }

  // Visible: Criterios de adjudicación de Acuerdos Marco (AAM-CBAM)
  public isVisibleFrameworkAgreementCriteria(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      return (model.type && model.type.identifier == 'AAM<>PROCEDIMIENTOSCONTRA') && (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier != 'CSDA<>SISTCOMPLEMENTARIO')
    }

    return false;
  }

  private static isVisibleAccountLine(model: any) {
    let visibleAnu = (model.classification && model.classification.complementarySystem &&
      model.classification.complementarySystem != 'AM<>SISTCOMPLEMENTARIO' && model.classification.complementarySystem != 'SDA<>SISTCOMPLEMENTARIO');
    let cleanBudget = ProcurementProjectValidations.isCleanBudget(model);

    if ((visibleAnu != undefined && visibleAnu) || !cleanBudget) {
      return true;
    }
    return false;
  }

  private static isVisibleLots(model: any) {
    let isMinorContract = false;
    if (model.type) {
      isMinorContract = model.type == undefined
        ? false
        : model.type.identifier == 'M<>PROCEDIMIENTOSCONTRA';
    }
    if (isMinorContract) {
      return false;
    }

    if (ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(model)) {
      return false;
    }

    return true;
  }

  // Visible desglose presupuestario
  public isVisibleHeaderBudgetBreakdown(model: any) {
    // Se visualiza la cabecera de desglose presuouestario, si existen anualidades o lotes
    let visibleBudgetAccountLine = ProcurementProjectValidations.isVisibleAccountLine(model);
    let visibleLotsPanel = ProcurementProjectValidations.isVisibleLots(model) && model.breakdownLot && model.breakdownLot.apportioned;
    if (visibleBudgetAccountLine || visibleLotsPanel) {
      return true;
    } else {
      return false;
    }

  }

  //esAbiertoSimplificado = type.equals("AS")
  private static isSimplifiedOpen(model: any) {
    let isSimplifiedOpen = false;
    if (model.type) {
      let isSimplifiedOpen =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier == 'AS<>PROCEDIMIENTOSCONTRA';
      return isSimplifiedOpen;
    }
    return false;

  }

  // Visible Garantia provisional
  public isVisibleprovisionalGuarantee(model: any) {
    // !esMenor && !esComprasCC && !esAbiertoSimpli
    if (!ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isCentralizedPurchases(model) && !ProcurementProjectValidations.isOpenSimplifiedAbreviated(model)) {
      return true;
    }
    return false;
  }

  public isEnabledProcurementCommittee(model: any) {
    return (
      !ProcurementProjectValidations.isTenderWithNegotiation(model)
    );
  }

  public valueProcurementCommittee(model: any) {
    if (ProcurementProjectValidations.isTenderWithNegotiation(model)) {
      return true;
    } else if (ProcurementProjectValidations.isNegotiatedWithoutPublicity(model) || ProcurementProjectValidations.isBasedFrameworkAgreement(model) || ProcurementProjectValidations.isTypeMode(model, 'N')) {
      return model.classification.procurementCommittee;
    } else {
      return null;
    }
  }

  public isVisibleProcurementCommittee(model: any) {
    let visible = false;
    if (model.type) {
      //if (model.type.identifier == 'LN<>PROCEDIMIENTOSCONTRA' || model.type.identifier == 'NSP<>PROCEDIMIENTOSCONTRA') {
      if (ProcurementProjectValidations.isNegotiated(model)) {
        visible = true;
      } else if (model.type.identifier == 'AAM<>PROCEDIMIENTOSCONTRA' && model.contractingSystem != undefined && model.contractingSystem != null) {
        visible = (model.contractingSystem.tenderBasedFrameworkAgreement != undefined && model.contractingSystem.tenderBasedFrameworkAgreement != null && model.contractingSystem.tenderBasedFrameworkAgreement);
      }
    }
    return visible;
  }

  public visibleFrameworkAgreementCriteria(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let isAM =
        model.classification.complementarySystem.identifier == 'AM<>SISTCOMPLEMENTARIO';

      // Si es un contrato basado y no tiene padre
      let isCBAM =
        model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

      return (isAM || isCBAM);
    }
    return false;
  }

  public isVisibleCriteriaConcretion(model: any) {
    // Solo es visible si tiene seleccionado la opcion "NO"
    if (model.classification && model.classification.complementarySystem) {
      let isAM =
        model.classification.complementarySystem.identifier == 'AM<>SISTCOMPLEMENTARIO';
      // Si es un contrato basado y no tiene padre
      let isCBAM =
        model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

      let isFrameworkAgreementCriteria = false;
      if (model.contractingSystem != null && model.contractingSystem.frameworkAgreementCriteria != null) {
        isFrameworkAgreementCriteria = model.contractingSystem.frameworkAgreementCriteria;
      } else {
        isFrameworkAgreementCriteria = null;
      }

      // Hay que verificar si esta activo la funcionalidad de expediente base sin padre
      let baseContractNoRelated = ProcurementProjectValidations.isActiveBaseContractNoRelated(model)
        && model.contractingSystem && model.contractingSystem.baseContractNoRelated;

      if (isAM || (isCBAM && (!baseContractNoRelated))) {
        if (isFrameworkAgreementCriteria != null && !isFrameworkAgreementCriteria) {
          return true;
        } else {
          return false;
        }
        // Contrato Basado sin padre
      } else if (isCBAM && (baseContractNoRelated)) {
        if (isFrameworkAgreementCriteria != null && isFrameworkAgreementCriteria) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  public static isActiveBaseContractNoRelated(model: any) {
    let activeBaseContractNoRelated =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isBaseContractNoRelated)
        ? model.context.configurations.isBaseContractNoRelated.value
        : false;

    if (activeBaseContractNoRelated) {
      return true;
    } else {
      return false;
    }
  }

  public isCatalogProcurementProject(model: any) {
    // Si es un contrato basado
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;

      if (contractFolderId && model.desglosableInfo['requestedMaterial']) {
        return model.desglosableInfo['requestedMaterial'].filter((material: RequestMaterialDTO) => {
          return (material.catalogId != undefined && material.catalogId != null);
        }).length > 0;
      }
    }
    return false;
  }



  public isVisibleBaseContractNoRelated(model: any) {
    let isCBAM = model.classification && model.classification.complementarySystem
      && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

    if (ProcurementProjectValidations.isActiveBaseContractNoRelated(model) && isCBAM) {
      return true;
    }
    return false;
  }



  public isEnabledFrameworkAgreementCriteria(model: any) {
    let enabled = true;
    if (model.classification && model.classification.complementarySystem) {

      let isCBAM =
        model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

      let baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated;

      if (isCBAM && !baseContractNoRelated) {
        enabled = false;
      }
    }
    return enabled;
  }

  // Contrato Basado con Acuerdo Marco Padre
  public isActiveBaseContractRelated(model: any) {
    let baseContractNoRelated = false;
    baseContractNoRelated = ProcurementProjectValidations.isActiveBaseContractNoRelated(model)
      && model.contractingSystem && model.contractingSystem.baseContractNoRelated;

    if (model.classification && model.classification.complementarySystem) {
      let isCSDA = model.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO';
      let isCBAM = model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

      if (isCSDA || isCBAM) {
        if (!baseContractNoRelated) {
          return true;
        }
      } else {
        return false;
      }
    }
    return false;
  }

  // Contrato Basado sin Padre
  public static isNoRelatedBaseContract(model: any) {
    let propertyBaseContractNoRelated = ProcurementProjectValidations.isActiveBaseContractNoRelated(model);
    let CBAMNoRelated = false;

    // Si esta activa la propiedad y esta seleccionado la opcion de si
    if (propertyBaseContractNoRelated && model.contractingSystem && model.contractingSystem.baseContractNoRelated
      && model.contractingSystem.baseContractNoRelated === true) {
      CBAMNoRelated = true;
    }
    return CBAMNoRelated;
  }



  public visibleRequestedMaterial_CBAM_CSDA(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let isCSDA = model.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO';
      let isCBAM = model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

      let isNoRelatedBaseContract = ProcurementProjectValidations.isNoRelatedBaseContract(model);
      // Si tiene padre el contrato basado, se introducen los materiales del padre
      if (isCSDA || (isCBAM && !isNoRelatedBaseContract)) {
        return true;
      }
    }
    return false;
  }

  //////  FUNCIONES PARA GOBERNANZA /////

  public editableNumLicitableLots(model: any) {
    if (model.breakdownLot && model.breakdownLot.apportioned && model.breakdownLot.tenderAllLots) {
      return false;
    } else {
      return true;
    }
  }

  public valueTotalAmount(model: any) {
    let total = (model.budget.amountExcludingTaxes || 0) + (model.budget.totalTaxes);
    let digits: number = 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((total + Number.EPSILON) * multiplier) / multiplier;
  }

  public valueCategory(model: any) {
    let visibleCategory = false;
    let cleanValue = false;
    if (ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
        // Visible Unicamente si esta desglosado en lotes el Acuerdo Marco
        if (model.contractingSystem.originalContractingSystemID.breakdownLot && model.contractingSystem.originalContractingSystemID.breakdownLot.apportioned) {
          visibleCategory = true;
        } else if (model.procurementProjectAM && model.procurementProjectAM.breakdownLot && model.procurementProjectAM.breakdownLot.apportioned) {
          visibleCategory = true;
        } else {
          // Para que almacene un valor
          cleanValue = false;
        }
      }
    }
    return false;

  }

  /*public valueUrgencyCode(model:any){
    if (model.context.configurations.isApplicableLegislationLCSP_RDL_3_20.value){
      return
    }

  }*/


  public static isApplicableLegislationLCSP_RDL_3_20(model: any) {
    if (model.applicableLegislation.identifier && model.applicableLegislation.identifier == '70<>VERSIONNORMATIVA') {
      return true;
    } else {
      return false;
    }
  }

  public clearHarmonizedRegulationRDL_3_20(model: any) {
    if (ProcurementProjectValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return false;
    } else {
      return true;
    }
  }

  public isVisiblePenaltyClauses(model: any) {
    // Se visualiza para la normativa distinto de 70
    let visible = !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isServiciesPublic(model);

    if (visible && !ProcurementProjectValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return true;
    } else {
      return false;
    }
  }

  public isVisiblePenaltyClausesOther(model: any) {
    // No se visualiza para la normativa 70
    let visible = !ProcurementProjectValidations.isMinorContrat(model) && !ProcurementProjectValidations.isServiciesPublic(model);

    if (visible && ProcurementProjectValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return true;
    } else {
      return false;
    }

  }

  /****************************FUNCIONES ASOCIADAS A LOS MODOS*********************************/
  /* Utilizadas desde las pantallas */

  // Metodo generico que devuelve si es el modo pasado por parametro
  public static isMode(model: any, mode: string, configurationsMode: any) {

    if (model.type) {
      if (model.type.identifier === mode) {
        return true;
      } else {
        let isModes = false;
        if (model.context && model.context.configurations && configurationsMode != undefined) {
          isModes = configurationsMode.value.some(
            t => t === model.type.identifier
          );
        }
        return isModes;
      }
    }
    return false;
  }

  // Metodo que indica si el tipo de procedimiento por pantalla contiene el modo asociado
  public static isTypeMode(model: any, mode: string) {

    let modes: string;
    let type: string;
    let t: string;

    if (model.type) {
      t = model.type.identifier;
      // Selecciona el identificador
      let type = t.substr(0, t.indexOf('<'));    //'M<>PROCEDIMIENTOSCONTRA'
      if (type === mode) {
        return true;
      } else {
        let existMode = false;
        if (model.context && model.context.configurations && model.context.configurations.typeModes != undefined) {
          modes = model.context.configurations.typeModes.value[type];
          /*if (modes.indexOf(mode) != -1) {
            return true;
          }*/
          let tModes = modes.split(";");
          tModes.forEach((value, index) => {
            if (tModes[index] === mode) {
              existMode = true;
            }
          });
        }
        return existMode;
      }
    }
    return false;
  }

  // MODO: MENOR
  //esMenor = modoProc.equals("M")
  public isMinorContractMode(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'M');
  }

  // MODO: ABIERTO
  //esAbierto =  modoProc.equals("A") || (esConcursoProyectos && !hayLimiteNumParticipantes)
  public isOpenContractMode(model: any) {
    let isOpenContract = ProcurementProjectValidations.isTypeMode(model, 'A');
    let isOpen =
      isOpenContract ||
      (ProcurementProjectValidations.isDesignContest(model) &&
        !ProcurementProjectValidations.participantsLimit(model));
    return isOpen;
  }

  // MODO: NEGOCIADO
  //esNegociado = modoProc.equals("N")
  public isNegotiatedMode(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'N');
  }

  // MODO: RESTRINGIDO
  //esNegociado = modoProc.equals("R") || (esConcursoProyectos && !hayLimiteNumParticipantes)
  public isRestrictedMode(model: any) {
    let isRestrictedContract = ProcurementProjectValidations.isTypeMode(model, 'R');;
    let isRestricted = isRestrictedContract ||
      (ProcurementProjectValidations.isDesignContest(model) &&
        ProcurementProjectValidations.participantsLimit(model));

    return isRestricted;
  }

  // MODO: DIALOGO COMPETITIVO modesCompetitiveDialogue
  //  esDialogoCompetitivo = modoProc.equals("DC")
  public isCompetitiveDialogueMode(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'DC');
  }

  // MODO: ADJUDICACION DE ACUERDO MARCO
  // esAdjudicacion de AM
  public isBasedFrameworkAgreementMode(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'AAM');
  }

  // MODO: COMPRAS CENTRALIZADAS
  public isCentralizedPurchases(model: any) {
    return ProcurementProjectValidations.isTypeMode(model, 'T');
  }

  //FUNCION DE BSM
  public valueManagementCompany(model: any) {
    let result = null;
    if (model._parent.organizationalUnit) {
      let promoterEntity;
      if (model._parent.organizationalUnit.entity) {
        promoterEntity = model._parent.organizationalUnit;
      } else {
        promoterEntity = model._parent.organizationalUnit.entityDTO;
      }

      if (model._parent.organizationalUnit.unitId && model.recipientCompany && model.recipientCompany.unitId) {
        if (promoterEntity.unitId === model.recipientCompany.unitId) {
          let organizationalUnit = model.recipientCompany;
          result = organizationalUnit;
        }
      }
    }
    if (result === null && model.managementCompany) {
      result = model.managementCompany;
    }
    return result;
  }

  public editableManagementCompany(model: any) {
    let result = true;
    if (model._parent.organizationalUnit) {
      let promoterEntity;
      if (model._parent.organizationalUnit.entity) {
        promoterEntity = model._parent.organizationalUnit;
      } else {
        promoterEntity = model._parent.organizationalUnit.entityDTO;
      }

      if (model._parent.organizationalUnit.unitId && model.recipientCompany && model.recipientCompany.unitId) {
        if (promoterEntity.unitId === model.recipientCompany.unitId) {
          let organizationalUnit = model.recipientCompany;
          result = false;
        }
      }
    }

    return result;
  }

  public isEnabledProcessingMode(model: any, evt: any) {
    let p: string;
    let valor: string;

    if (model.phase) {
      p = model.phase.identifier;
      // Selecciona el identificador
      let phase = p.substr(0, p.indexOf('<'));
      // Fases que habiitan el modo de tramitación
      if (model?.context?.configurations?.phasesEnabledProcessingMode) {
        valor = '';
        valor = model?.context?.configurations?.phasesEnabledProcessingMode.value;
        var phases = valor.split(';');
        let obj = phases.find(
          item => item == phase
        );
        if (obj && obj.length > 0) {
          return true;
        }
      }
    } else {
      // Si no tiene fase está habilitado para que lo pueda seleccionar
      return true;
    }
    return false;
  }

  public valueTotalAmounLot(model: any) {
    if (model.budget.totalTaxes == null || model.budget.totalTaxes == undefined) {
      return model.budget.amountExcludingTaxes;
    } else {
      let digits: number = 2;
      let multiplier = Math.pow(10, digits);
      return Math.round((model.budget.amountExcludingTaxes + model.budget.totalTaxes + Number.EPSILON) * multiplier) / multiplier;
    }
  }

  // Funciones para EFORMS: B2B

  public isVisibleProcedureCharacteristics(model: any) {


    let euDirective_2014_24_EU = false;
    let euDirective_2014_25_EU = false;

    if (model.euDirective) {
      euDirective_2014_24_EU = model.euDirective.identifier == '2014/24/EU<>DIRECTIVA_UE';
      euDirective_2014_25_EU = model.euDirective.identifier == '2014/25/EU<>DIRECTIVA_UE';
    }

    if (euDirective_2014_24_EU || euDirective_2014_25_EU) {
      return true;
    }

    return false;
  }

  public isVisibleFinancialConditions(model: any) {


    let euDirective_2009_81_EC = false;
    let euDirective_2014_25_EU = false;

    if (model.euDirective) {
      euDirective_2009_81_EC = model.euDirective.identifier == '2009/81/EC<>DIRECTIVA_UE';
      euDirective_2014_25_EU = model.euDirective.identifier == '2014/25/EU<>DIRECTIVA_UE';
    }

    if (euDirective_2009_81_EC || euDirective_2014_25_EU) {
      return true;
    }

    return false;
  }

  public isVisibleAgreementPublicProcurement(model: any) {

    let euDirective_2014_23_EU = false;
    let euDirective_2014_24_EU = false;
    let euDirective_2014_25_EU = false;


    if (model.euDirective) {
      euDirective_2014_23_EU = model.euDirective.identifier == '2014/23/EU<>DIRECTIVA_UE';
      euDirective_2014_24_EU = model.euDirective.identifier == '2014/24/EU<>DIRECTIVA_UE';
      euDirective_2014_25_EU = model.euDirective.identifier == '2014/25/EU<>DIRECTIVA_UE';
    }

    if (euDirective_2014_23_EU || euDirective_2014_24_EU) {
      return true;
    }
    if (euDirective_2014_25_EU) {
      return true;
    }

    return false;
  }

  public isVisibleTendererLegalForm(model: any) {
    let euDirective_2009_81_EC = false;
    let euDirective_2014_25_EU = false;

    if (model.euDirective) {
      euDirective_2009_81_EC = model.euDirective.identifier == '2009/81/EC<>DIRECTIVA_UE';
      euDirective_2014_25_EU = model.euDirective.identifier == '2014/25/EU<>DIRECTIVA_UE';
    }

    if (euDirective_2009_81_EC) {
      return true;
    }

    if (euDirective_2014_25_EU) {
      return true;
    }

    return false;

  }

  public isVisibleUnnecessaryNegotiation(model: any) {

    if (ProcurementProjectValidations.isAssociationForInnovation(model) ||
      ProcurementProjectValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectValidations.isTenderWithNegotiation(model)) {
      return true;
    }

    return false;
  }

  public isVisibleExclusionReason(model: any) {
    let isMinorContract = false;
    let isAAM = false;
    if (model.type) {
      isMinorContract = model.type === undefined
        ? false
        : model.type.identifier === 'M<>PROCEDIMIENTOSCONTRA';
      isAAM = model.type === undefined
        ? false
        : model.type.identifier === 'AAM<>PROCEDIMIENTOSCONTRA';
    }
    if (!isMinorContract && !isAAM) {
      return true;
    }
    return false;
  }

  public isVisibleNumMaxContractExt(model: any) {


    let euDirective_2009_81_EC = false;
    let euDirective_2014_25_EU = false;

    if (model.euDirective) {
      euDirective_2009_81_EC = model.euDirective.identifier === '2009/81/EC<>DIRECTIVA_UE';
      euDirective_2014_25_EU = model.euDirective.identifier === '2014/25/EU<>DIRECTIVA_UE';
    }

    if (euDirective_2009_81_EC) {
      return true;
    }

    if (euDirective_2014_25_EU) {
      return true;
    }

    return false;

  }
  public isVisibleAcceptedVariants(model: any) {


    let euDirective_2014_24_EU = false;

    if (model.euDirective) {
      euDirective_2014_24_EU = model.euDirective.identifier === '2014/24/EU<>DIRECTIVA_UE';

    }

    if (euDirective_2014_24_EU) {
      return true;
    }


    return false;

  }

  public isVisibleCleanVehicleDirective(model: any) {


    let euDirective_2014_24_EU = false;
    let euDirective_2014_25_EU = false;

    if (model.euDirective) {
      euDirective_2014_24_EU = model.euDirective.identifier === '2014/24/EU<>DIRECTIVA_UE';
      euDirective_2014_25_EU = model.euDirective.identifier === '2014/25/EU<>DIRECTIVA_UE';
    }

    if (euDirective_2014_24_EU) {
      return true;
    }

    if (euDirective_2014_25_EU) {
      return true;
    }

    return false;

  }

  public isVisibleNonElectronicTenderReason(model: any): boolean {
    return !!model?.euDirective?.identifier && model?.euDirective?.identifier !== 'N/A<>DIRECTIVA_UE' &&
      model?.classification?.submissionMethodCode === false;
  }


  //
  public isVisibleProjectRelated(model: any) {
    //if (!UtilidadesScript.esGENFEScript() || (gp.getCampoOrigen("LISTADOCUMENTO") != null && gp.getCampoOrigen("LISTADOCUMENTO").equals("SG")) || isPerfilContratante()) {
    let resultado = false;
    if (model.context && model.context.configurations && model.context.configurations.isVisibleRelatedProject !== undefined) {
      model.context.configurations.isVisibleRelatedProject.value.forEach(typeExp => {
        if ((typeExp + '<>PROCEDIMIENTOSCONTRA') === model.type.identifier) {
          resultado = true;
        }
      });
      /*for (let i = 0; i <= model.context.configurations.isVisibleRelatedProject.value.length - 1; i++) {
        if (model.context.configurations.isVisibleRelatedProject.value[i].equals(model.type.identifier.id)) {
          resultado = true;
        }
      }*/
      /*let listaExp = model.context.configurations.isVisibleRelatedProject.value.split(';');
      listaExp.forEach(typeExp => {
        if (typeExp.equals(model.type)) {
          resultado = true;
        }
      });*/
    }
    return resultado;
  }

  public isEnabledActiveProjects(model: any) {
    //propiedad PROYECTOS_ACTIVOS
    let resultado = false;
    if (model.context && model.context.configurations && model.context.configurations.isActiveProjects !== undefined) {
      resultado = model.context.configurations.isActiveProjects.value;
    }
    return resultado;
  }

  public isEnabledActiveProjectsTable(model: any) {
    //propiedad PROYECTOS_ACTIVOS
    let resultado = false;
    if (model._parent) {
      if (model._parent.context && model._parent.context.configurations && model._parent.context.configurations.isActiveProjects !== undefined) {
        resultado = model._parent.context.configurations.isActiveProjects.value;
      }
    } else {
      if (model.context && model.context.configurations && model.context.configurations.isActiveProjects !== undefined) {
        resultado = model.context.configurations.isActiveProjects.value;
      }
    }

    return resultado;
  }



}
